import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { AppContext } from '../../Store';
import { useTranslation } from 'react-i18next';
import Toast from '../toasts/Toast';
import DarkFullScreenOverlay from '../overlays/DarkFullScreenOverlay';
import { MESSAGE_CONTEXTS } from '../../helpers/server-messages';

function ServerMessages({ excludeEmailConfirmation = false }) {
	const { t } = useTranslation('translation');
	
	const [state, dispatch] = useContext(AppContext);

	let translatationNotLoaded = false;
	if (t('server.error.headline') === 'server.error.headline') {
		translatationNotLoaded = true;	
	}

	return (
		<div>
			{state.showServerError &&
					<DarkFullScreenOverlay>
						<Toast
							messageType='error'
							messageHeadline={t('server.error.headline')}
							messageContent={state.serverErrorMessage}
							closeCallback={() => { dispatch({ type: 'HIDE_SERVER_ERROR' }); }}
							life={translatationNotLoaded ? 1000000 : 10000}
							showReloadPageLink={translatationNotLoaded}
						/>
					</DarkFullScreenOverlay>
			}

			{state.showServerSuccess &&
				<DarkFullScreenOverlay>
					<Toast
						messageType='success'
						messageHeadline={t('server.success.headline')}
						messageContent={state.serverSuccessMessage}
						closeCallback={() => { dispatch({ type: 'HIDE_SERVER_SUCCESS' }); }}
						life={10000}
					/>
				</DarkFullScreenOverlay>
			}
			{state.serverMessages && state.serverMessages.map((message, i) =>
				<>
					{!(excludeEmailConfirmation && MESSAGE_CONTEXTS.EMAIL_CONFIRMATION.some((context) => context === message.context)) && (
						<Toast
							key={`message-${i + 1}`}
							messageType={message.type.toLowerCase()}
							messageHeadline={message.type.toLowerCase() === 'success' ? t('server.success.headline') : t('server.error.headline')}
							messageContent={t(message.code)}
							life={10000}
							verticalOrder={i + 1}
						/>
					)}
				</>
			)}
		</div>
	);
}

ServerMessages.propTypes = {
	excludeEmailConfirmation: PropTypes.bool,
};
	
export default ServerMessages;